import styled from 'styled-components';

export const Container = styled.div`
  background-color: #121212;
  height: 100vh;
  width: 100vw;
`;
